import { PassFailBackgroundWrapper } from './styled';
import { useTheme } from '@simplywallst/ui-core';
import { useChartDefinitionsContext } from '@/components/ChartDefinitionsContext';

interface Props {
  y?: number;
  width?: number;
  height?: number;
  percent: number;
}

const PassFailBackground = ({ percent, y, width, height }: Props) => {
  const theme = useTheme();
  const { chartFailPattern } = useChartDefinitionsContext();
  const backgroundPercent = Math.max(Math.min(100, percent), 0);

  return (
    <PassFailBackgroundWrapper y={y} width={width} height={height} rx="2">
      <rect
        x="0"
        y="0"
        width={`${backgroundPercent}%`}
        height="100%"
        fill={theme.color.good}
      />
      <rect
        x={`${backgroundPercent}%`}
        y="0"
        width={`${100 - backgroundPercent}%`}
        height="100%"
        fill={chartFailPattern}
      />
    </PassFailBackgroundWrapper>
  );
};

export default PassFailBackground;
